/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react"
import { toAbsoluteUrl } from "../../../../_helpers"
import { Link } from "react-router-dom"
import { Carousel } from "antd"
import { useDispatch, useSelector, shallowEqual } from "react-redux"
import {
  categoryFilter,
  brandFilter,
  searchKeyword,
  topSellerFilter
} from "../../../../../actions/common"
import { Chip } from "@material-ui/core"
import { useHistory } from "react-router-dom"

export function AsideMenuList({ layoutProps }) {
  // Example icon mapping for categories
  const categoryIconMap = {
    'accessories': 'fa-bag-shopping',
    'apparel': 'fa-shirt',
    "jewelry": "fa-gem",
    "plussize": "fa-person-dress",
    "madeinusa": "fa-flag-usa",
    "restockedpopularitems": "fa-fire",
    "sale": "fa-tags",
    "newarrivals": "fa-wand-magic-sparkles",
    "mens": "fa-user-tie"
  };
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [catDisplayName, setcatDisplayName] = useState(false)
  const [searchValue, setsearchValue] = useState("")
  const [clearSearchflag, setclearSearchflag] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()

  const headerMenu = [
    "/my-orders",
    "/marketing-material",
    "/my-account",
    "/help",
    "/return",
    "/cart",
    "/trunkey",
    "/upgrade-save"
  ]

  const splitTitleAndCount = (title) => {
    const text = String(title ?? "")
    const match = text.match(/\((\d+)\)\s*$/)
    return {
      name: text.replace(/\s*\(\d+\)\s*$/, "").trim(),
      count: match ? match[1] : null
    }
  }

  const renderTree = (nodes) =>
    Array.isArray(nodes) ? (
      nodes.map((node, index) => {
        const { name, count } = splitTitleAndCount(node.title)
        // Normalize category title: remove spaces, convert to lowercase
        const normalizedTitle = name.replace(/\s+/g, "").toLowerCase()
        const iconClass = categoryIconMap[normalizedTitle] || 'fa-folder-open';
        return (
          <li
            className={`${selectedCategory === node.title ? "item-selected " : ""}menu-item${Array.isArray(node.children) && node.children.length > 0
              ? " menu-item-submenu"
              : ""
              }`}
            aria-haspopup="true"
            data-menu-toggle="hover"
            key={index}
          >
            <a className="menu-link menu-toggle" href={void 0}>
              {/* Icon for first-level only, from mapping */}
              <span
                className="menu-text d-flex justify-content-between items-center gap-2"
              >
                <div className="d-flex items-center gap-2" onClick={(e) => { selected_category(e, node) }}>
                  <i className={`fa-solid ${iconClass} text-slate-500 w-4 text-center`}></i>
                  <span className="category-name">{name}</span>
                </div>
                <div className="cat-count-sec d-flex items-center gap-2">
                  {count !== null && (
                    <span className="bg-slate-100 text-slate-500 text-xs px-2 py-0.5 rounded-full count category-count">
                      {count}
                    </span>
                  )}
                  {Array.isArray(node.children) && node.children.length > 0 && (
                    <i class="fa-solid fa-chevron-down text-xs"></i>
                  )}
                </div>
              </span>
            </a>

            {Array.isArray(node.children) && node.children.length > 0 ? (
              <div className="menu-submenu">
                <ul className="menu-subnav">
                  {node.children?.map((child_node) => renderTree(child_node))}
                </ul>
              </div>
            ) : null}
          </li>
        )
      })
    ) : (
      <li
        className={`${selectedCategory === nodes.title ? "item-selected " : ""}menu-item${Array.isArray(nodes.children) && nodes.children.length > 0
          ? " menu-item-submenu"
          : ""}`}
        aria-haspopup="true"
        data-menu-toggle="hover"
        key={nodes.key}
      >
        <a className="menu-link menu-toggle flex items-center gap-3 justify-between" href={void 0}>
          {/* No icon for submenu categories */}
          <span
            className="flex text-sm py-1.5 px-2 text-slate-500 hover:text-slate-800 rounded"
            onClick={(e) => {
              selected_category(e, nodes)
            }}
          >
            {nodes.title?.replace(/\s*\(\d+\)$/, '')}
          </span>
          {nodes.title.match(/\((\d+)\)$/) && (
            <span className="bg-slate-100 text-slate-500 text-xs px-2 py-0.5 rounded-full count">{nodes.title.match(/\((\d+)\)$/)[1]}</span>
          )}
          {Array.isArray(nodes.children) && nodes.children.length > 0 && (
            <i class="fa-solid fa-chevron-down text-xs"></i>
          )}
        </a>

        {Array.isArray(nodes.children) && nodes.children.length > 0 ? (
          <div className="menu-submenu">
            <ul className="menu-subnav">
              {nodes.children?.map((child_node) => renderTree(child_node))}
            </ul>
          </div>
        ) : null}
      </li>
    )

  function addQueryParamsToURL(newParams) {
    // Get the current URL
    const currentURL = window.location.href

    // Parse the URL to extract the existing query parameters
    const url = new URL(currentURL)

    // Add or update the new query parameters
    for (const param in newParams) {
      url.searchParams.set(param, newParams[param])
    }

    const pathAndQuery = "/all-inventory" + url.search

    // Build the updated URL with the combined parameters
    const updatedURL = pathAndQuery.toString()

    // Use history.pushState to update the browser URL
    history.push(updatedURL)
  }

  const { categories, searchKey, sortValue, topSellerActive } = useSelector(
    (state) => ({
      categories: state.common && state.common?.categoryID,
      searchKey: state.common && state.common?.searchKeyword,
      sortValue: state.common && state.common?.sortFilter,
      topSellerActive: state.common && state.common?.topSellerActive
    }),
    shallowEqual
  )

  // Sync chip + sidebar highlight whenever topSellerActive changes in Redux.
  // Covers "View All Top Sellers →" button which dispatches topSellerFilter(true)
  // without going through the sidebar click handler.
  useEffect(() => {
    if (topSellerActive) {
      setSelectedCategory("TOP SELLERS")
      setcatDisplayName(true)
    } else if (selectedCategory === "TOP SELLERS") {
      setSelectedCategory(null)
      setcatDisplayName(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topSellerActive])

  // const getRedirectionURL = (category,search,sort) => {
  //   return `/all-inventory?category=${category || ''}search=${search || ''}sort=${sort || 'new_to_old'}`
  // }

  useEffect(() => {
    if (categories === null || searchKey === null || sortValue === null) {
      if (categories === null) {
        setcatDisplayName(false)
        setSelectedCategory(null)
      }

      if (searchKey === null) {
        setclearSearchflag(false)
        setsearchValue("")
      }


      // getRedirectionURL(categories,searchKey,sortValue)
    }
  }, [categories, searchKey, sortValue])

  // When navigating away from all-inventory, clear the top seller filter
  // so normal products show when the user returns.
  useEffect(() => {
    if (
      history?.location?.pathname !== "/all-inventory" &&
      selectedCategory === "TOP SELLERS"
    ) {
      dispatch(topSellerFilter(false))
      setSelectedCategory(null)
      setcatDisplayName(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname])

  useEffect(() => {
    if (categories !== null) {
      dispatch(searchKeyword({ searchKeyword: null }))
      setclearSearchflag(false)
      setsearchValue("")
      // getRedirectionURL(categories,'',sortValue)
    } else {
      setcatDisplayName(false)
      setSelectedCategory(null)
      // getRedirectionURL(categories,searchKey,sortValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories])

  useEffect(() => {
    if (searchKey !== null) {
      dispatch(categoryFilter({ categoryId: null }))
      setcatDisplayName(false)
      setSelectedCategory(null)
      // getRedirectionURL('',searchKey,sortValue)
    } else {
      setclearSearchflag(false)
      setsearchValue("")
      // getRedirectionURL(categories,searchKey,sortValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey])

  const selected_category = (event, node) => {
    // Reset brand filter when selecting a category so category contains all brands
    dispatch(brandFilter({ brandFilter: null }))
    dispatch(categoryFilter({ categoryId: node.key }))
    setcatDisplayName(true)
    setSelectedCategory(node.title)

    if (window.location.pathname !== "/all-inventory") {
      // if (window.location.pathname !== "/my-inventory") {
      //   history.push(`/all-inventory?filter=true`);
      const newQueryParams = {
        filter: true
      }

      addQueryParamsToURL(newQueryParams)
      // }
    }
    // getRedirectionURL(node.key,searchKey,sortValue)
  }

  const clear_category = () => {
    dispatch(topSellerFilter(false))
    dispatch(categoryFilter({ categoryId: null }))
    setcatDisplayName(false)
    setSelectedCategory(null)
    // getRedirectionURL(null,searchKey,sortValue)
  }

  // check shop exist or not
  const path = window.location.href.replace(/^.+\?/i, "")
  const searchParams = new URLSearchParams(path)
  const shop = searchParams.get("shop")
  const host = searchParams.get("host")

  const searchVal = () => {
    if (searchValue !== "") {
      if (headerMenu.includes(history?.location?.pathname)) {
        const redirectURL = `/all-inventory?shop=${shop}&host=${host}`
        history.push(redirectURL)
        setTimeout(() => {
          // Clear brand filter when searching to mirror category behavior
          dispatch(brandFilter({ brandFilter: null }))
          dispatch(searchKeyword({ searchKeyword: searchValue.trim() }))
          setclearSearchflag(true)
        }, 3000)
      } else {
        setTimeout(() => {
          // Clear brand filter when searching to mirror category behavior
          dispatch(brandFilter({ brandFilter: null }))
          dispatch(searchKeyword({ searchKeyword: searchValue.trim() }))
          setclearSearchflag(true)
        }, 2000)
      }

      // dispatch(searchKeyword({ searchKeyword: searchValue.trim() }))
      // setclearSearchflag(true)
      // getRedirectionURL(categories,searchValue.trim(),sortValue)
    }
  }

  const clearSearch = () => {
    dispatch(searchKeyword({ searchKeyword: null }))
    setclearSearchflag(false)
    setsearchValue("")
    // getRedirectionURL(categories,null,sortValue)
  }



  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      searchVal()
    }
  }

  useEffect(() => {
    if (
      headerMenu.includes(history?.location?.pathname) &&
      (categories !== null || searchKey !== null || sortValue !== null)
    ) {
      if (categories) {
        dispatch(categoryFilter({ categoryId: null }))
        setcatDisplayName(false)
        setSelectedCategory(null)
      }

      if (searchKey) {
        dispatch(searchKeyword({ searchKeyword: null }))
        setclearSearchflag(false)
        setsearchValue("")
      }
      // console.log("Need to remove.......")
      // var redirectionURL = getRedirectionURL(categories,searchKey,sortValue)
      // var redirectionURL = '/all-inventory?shop=myonlineteststoreforapp.myshopify.com&host=YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUvbXlvbmxpbmV0ZXN0c3RvcmVmb3JhcHA&bypass=22868300104343534024&redirect=true'
      // history.push(redirectionURL)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories, history.location.pathname, searchKey, sortValue])

  return (
    <>
      {/* begin::Menu Nav */}
      <div className="sidebar-nav pb-5">
        <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4">Categories</h3>
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
          {/* Categories */}
          {catDisplayName && (
            <li
              className="menu-section"
              style={{ margin: "0px", justifyContent: "center" }}
            >
              <Chip
                variant="outlined"
                label={selectedCategory.replace(/ *\([^)]*\) */g, "")}
                className="mr-2 mb-2 font-size-h6 text-center text-uppercase"
                onClick={clear_category}
                onDelete={clear_category}
              />
            </li>
          )}
          {(() => {
            const tree = Array.isArray(layoutProps.categoryTree)
              ? layoutProps.categoryTree
              : [];
            const isTSActive = selectedCategory === "TOP SELLERS";
            const topSellersClick = (e) => {
              if (e && e.preventDefault) e.preventDefault();
              // Filter products in-place on All Inventory (no separate page).
              dispatch(brandFilter({ brandFilter: null }));
              dispatch(categoryFilter({ categoryId: null }));
              dispatch(topSellerFilter(true));
              setSelectedCategory("TOP SELLERS");
              setcatDisplayName(true);
              if (window.location.pathname !== "/all-inventory") {
                history.push(`/all-inventory?shop=${shop}&host=${host}`);
              }
            };
            const TopSellersItem = (
              <li
                key="__top_sellers__"
                className={`${isTSActive ? "item-selected " : ""}menu-item`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <a
                  className="menu-link menu-toggle"
                  href={void 0}
                  onClick={topSellersClick}
                >
                  <span className="menu-text d-flex justify-content-between items-center gap-2">
                    <div className="d-flex items-center gap-2">
                      <i className="fa-solid fa-fire text-slate-500 w-4 text-center"></i>
                      <span className="category-name">TOP SELLERS</span>
                    </div>
                    <div className="cat-count-sec d-flex items-center gap-2">
                      <span
                        className="text-white text-xs font-bold px-2 py-0.5 rounded"
                        style={{
                          background: "#ef4458",
                          letterSpacing: "0.5px",
                          lineHeight: 1.4
                        }}
                      >
                        NEW
                      </span>
                    </div>
                  </span>
                </a>
              </li>
            );
            return (
              <>
                {tree.length > 0 && renderTree([tree[0]])}
                {TopSellersItem}
                {tree.length > 1 && renderTree(tree.slice(1))}
              </>
            );
          })()}

          {/* Applications */}
          {/* begin::section */}
          {/* 
        <li className="menu-section ">
          <h4 className="menu-text font-size-h4">Search</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>

        <li
          className="menu-section"
          style={{ margin: "5px", padding: "0 15px" }}
        >
          <div className="form-group row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  aria-describedby="basic-addon2"
                  onChange={(e) => setsearchValue(e.target.value)}
                  value={searchValue}
                  onKeyDown={handleKeypress}
                />
                <div className="input-group-append">
                  <span
                    className="input-group-text"
                    onClick={searchVal}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="flaticon2-search-1 icon-md"></i>
                  </span>
                </div>
              </div>
              {clearSearchflag && (
                <a
                  href={void 0}
                  className="btn submit"
                  style={{ float: "right", fontSize: "12px" }}
                  id="clear_search"
                  onClick={clearSearch}
                >
                  Clear &nbsp;
                  <i className="quick-search-close ki ki-close icon-sm text-muted"></i>
                </a>
              )}
            </div>
          </div>
        </li> */}



          {/* <div className="form-group row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <Link to={{ pathname: 'upgrade-save' }}><img src={toAbsoluteUrl('assets/images/annualplan.png')} alt="Upgrade & Save" className="img-fluid pr-5 pl-5" /></Link>
          </div>
        </div>
        <hr />
        <div className="form-group row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <Link to={{ pathname: "https://www.myonlinefashionstore.com/products/pre-programmed-pre-designed-pre-loaded-with-our-items-ready-to-launch-website" }} target="_blank|_self|_parent|_top|app-iframe"><img src={toAbsoluteUrl('assets/images/99PACKAGE.jpg')} alt="99 Package" className="img-fluid pr-5 pl-5" /></Link>
          </div>
        </div>
        <hr />
        <div className="form-group row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <Link to={{ pathname: "https://www.myonlinefashionstore.com/pages/custom-packaging" }} target="_blank|_self|_parent|_top|app-iframe"><img src={toAbsoluteUrl('assets/images/SQUARELAYOUT.jpg')} alt="SQUARELAYOUT" className="img-fluid pr-5 pl-5" /></Link>
          </div>
        </div>
        <hr />
        <div className="form-group row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <Carousel>
              <div> <img src={toAbsoluteUrl('assets/images/SOLDmar2021.jpg')} alt="SOLDmar2021.jpg" className="img-fluid pr-5 pl-5" /> </div>
              <div> <img src={toAbsoluteUrl('assets/images/HELPFULTIPS2.jpg')} alt="HELPFULTIPS2.jpg" className="img-fluid pr-5 pl-5" /> </div>
              <div> <img src={toAbsoluteUrl('assets/images/HELPFULTIPS3.jpg')} alt="HELPFULTIPS3.jpg" className="img-fluid pr-5 pl-5" /> </div>
              <div> <img src={toAbsoluteUrl('assets/images/HELPFULTIPS4.jpg')} alt="HELPFULTIPS4.jpg" className="img-fluid pr-5 pl-5" /> </div>
              <div> <img src={toAbsoluteUrl('assets/images/HELPFULTIPS5.jpg')} alt="HELPFULTIPS5.jpg" className="img-fluid pr-5 pl-5" /> </div>
              <div> <img src={toAbsoluteUrl('assets/images/HELPFULTIPS6.jpg')} alt="HELPFULTIPS6.jpg" className="img-fluid pr-5 pl-5" /> </div>
              <div> <img src={toAbsoluteUrl('assets/images/HELPFULTIPS7.jpg')} alt="HELPFULTIPS7.jpg" className="img-fluid pr-5 pl-5" /> </div>
              <div> <img src={toAbsoluteUrl('assets/images/HELPFULTIPS8.jpg')} alt="HELPFULTIPS8.jpg" className="img-fluid pr-5 pl-5" /> </div>
              <div> <img src={toAbsoluteUrl('assets/images/HELPFULTIPS9.jpg')} alt="HELPFULTIPS9.jpg" className="img-fluid pr-5 pl-5" /> </div>
            </Carousel>
          </div>
        </div> */}
          {/* end:: section */}
        </ul>
      </div>
      {/* end::Menu Nav */}

      {/* begin::Pricing Information */}
      <div className="cc-pricing-btns pt-5 pb-5">
        <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4">Update Pricing</h3>
        <ul className="cc-pricing-btn-hover">
          <li className="mb-1">
            <button className="bg-slate-600 hover:bg-brand-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors shadow-sm w-full text-left gray-btn flex items-center gap-2"
              onClick={() => history.push(`/pricing-rule?shop=${shop}&host=${host}`)}>
              <i className="fa-solid fa-sliders text-white w-4 text-center"></i>
              Set Pricing Rule
            </button>
          </li>
          <li className="mb-1">
            <button className="bg-slate-600 hover:bg-brand-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors shadow-sm w-full text-left gray-btn flex items-center gap-2"
              onClick={() => history.push(`/help-sale-product-price-resync?shop=${shop}&host=${host}`)}>
              <i className="fa-solid fa-rotate text-white w-4 text-center"></i>
              Sale Price Resync
            </button>
          </li>
          <li>
            <button className="bg-slate-600 hover:bg-brand-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors shadow-sm w-full text-left gray-btn flex items-center gap-2"
              onClick={() => history.push(`/help-product-price-resync?shop=${shop}&host=${host}`)}>
              <i className="fa-solid fa-rotate text-white w-4 text-center"></i>
              Product Price Resync
            </button>
          </li>
        </ul>
      </div>
      {/* end::Pricing Information */}
    </>
  )
}
